module.exports = __webpack_public_path__ + "static/media/C14.2b260ffd.png";